import { FC } from 'react';
import { useAppSelector } from '@app/hooks/useReduxToolkit';
import { UserState } from 'state-services';
import { CaseQueueScheduleRequest } from 'type-declarations';
import { hasCapabilityPermission } from '@app/shared/permissions';
import { UserCapabilities } from '@app/shared/constants';
import { SimpleCrudTable } from 'rhyme-component-library';
import { holidaySchedulesColumns, newRecord } from './constants';
import HolidayScheduleDialog from './HolidayScheduleDialog';
import {
	useGetHolidaySchedulesQuery,
	usePostHolidayScheduleMutation,
	usePutHolidayScheduleMutation,
	useDeleteHolidayScheduleMutation,
} from './holidaySchedulesApi';

const HolidaySchedules: FC = () => {
	const user = useAppSelector<UserState>((state) => state.user);
	const { capabilities } = user.activeScope;
	const selectedOrganizationId = user.activeScope.scopeValue;
	const isEditable = hasCapabilityPermission(capabilities, [
		UserCapabilities.ModifyProviderOrganizationCaseQueue,
	]);

	// RTK Hooks
	const { data: holidaySchedules, isFetching } = useGetHolidaySchedulesQuery({
		selectedOrganizationId,
	});
	const [postHolidaySchedule] = usePostHolidayScheduleMutation();
	const [putHolidaySchedule] = usePutHolidayScheduleMutation();
	const [deleteHolidaySchedule] = useDeleteHolidayScheduleMutation();

	//  Event Handlers passed to <SimpleCrudTable /> as props
	const handleCreateRecord = (caseQueueScheduleRequest: CaseQueueScheduleRequest): void => {
		postHolidaySchedule({ selectedOrganizationId, body: caseQueueScheduleRequest });
	};
	const handleEditRecord = (
		caseQueueScheduleRequest: CaseQueueScheduleRequest,
		id: string
	): void => {
		putHolidaySchedule({ selectedOrganizationId, body: caseQueueScheduleRequest, id });
	};
	const handleDeleteRecord = (id: string): void => {
		deleteHolidaySchedule({ selectedOrganizationId, id });
	};

	return (
		<>
			<SimpleCrudTable
				isLoading={isFetching}
				headers={holidaySchedulesColumns}
				data={holidaySchedules}
				isEditable={isEditable}
				addBtnLabel="Add Holiday Schedule"
				CreateAndEditDialogComponent={HolidayScheduleDialog}
				deleteDialogTitle="Are you sure you want to delete this holiday schedule?"
				baseRecord={newRecord}
				createAction={handleCreateRecord}
				editAction={handleEditRecord}
				deleteAction={handleDeleteRecord}
			/>
		</>
	);
};

export default HolidaySchedules;
